import React from 'react';

import { FullLayout } from 'app/components/Layout/FullLayout';
import { Outlet } from 'react-router';

export const AuthPage = () => {
  return (
    <FullLayout>
      <Outlet></Outlet>
    </FullLayout>
  );
};
